import Typography from "@/components/kit/Typography";
import classNames from "classnames";
import React from "react";

const StepWrapper = ({
  children,
  title,
  description,
  className,
}: {
  children: React.ReactNode;
  title: React.ReactNode;
  description: string;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "w-full pt-5 pb-3  h-full  border flex flex-col border-gray-100 rounded-lg overflow-y-auto",
        className,
      )}
    >
      <div className="flex mb-[26px] flex-col gap-1 px-6">
        <Typography variant="Title4-Regular">{title}</Typography>
        <Typography
          variant="Body2-Regular"
          className="!text-gray-300 !text-[13px]"
        >
          {description}
        </Typography>
      </div>

      {children}
    </div>
  );
};

export default StepWrapper;
